import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Table } from 'reactstrap';
import { connect } from 'react-redux';
import { deleteEmployee } from './actions';
import { getEmployees } from './reducer';
import { hasMutation } from './utils';

class EmployeeList extends Component {
  deleteEmployee = id => {
    this.props.deleteEmployee(id, 'cs');
  };

  renderTable = () => {
    const { employees } = this.props;

    return employees.map((item, index) => {
      const hasCs = hasMutation(item, 'cs');
      const hasEn = hasMutation(item, 'en');
      return (
        <tr key={index}>
          <td>
            {hasCs
              ? `${item.name.cs} ${item.surname.cs}`
              : hasEn
                ? `${item.name.en} ${item.surname.en}`
                : ''}
          </td>
          <td>
            <Link
              to={{
                pathname: hasCs
                  ? `/zamestnanci/edit/${item.id}/cs`
                  : `/zamestnanci/new`,
                state: { id: item.id, lang: 'cs', disableSelect: true }
              }}
            >
              {hasCs ? 'Upravit cs' : 'Vytvořit cs'}
            </Link>
          </td>
          <td>
            <Link
              to={{
                pathname: hasEn
                  ? `/zamestnanci/edit/${item.id}/en`
                  : `/zamestnanci/new`,
                state: { id: item.id, lang: 'en', disableSelect: true }
              }}
            >
              {hasEn ? 'Upravit en' : 'Vytvořit en'}
            </Link>
          </td>
          <td>{item.updated}</td>
        </tr>
      );
    });
  };

  render() {
    const { employees } = this.props;

    if (employees.length === 0) {
      return <div>Seznam zaměstnanců je prázdný</div>;
    }

    return (
      <Table>
        <thead>
          <tr>
            <th>Název</th>
            <th>Cs</th>
            <th>En</th>
            <th>Naposledy upraveno</th>
          </tr>
        </thead>
        <tbody>{this.renderTable()}</tbody>
      </Table>
    );
  }
}

const mapStateToProps = state => {
  return {
    employees: getEmployees(state)
  };
};

export default connect(
  mapStateToProps,
  { deleteEmployee }
)(EmployeeList);



// WEBPACK FOOTER //
// ./src/modules/EmployeeList/index.js